(() => {
  // define custom html element to build collection swiper carousel on /collections/outdoor-gear page for STS NA only 
  class ActivityContainer extends HTMLElement {

    constructor() {
      super();

      this.slidesPerView = this.hasAttribute('slides-per-view') ? Number(this.getAttribute('slides-per-view')) : 3;
      this.init();
    }

    init() {
      /**
       * Prevent initialization if the Swiper plugin is missing
       */
      if (!window.Swiper) {
        return;
      }

      this.show();

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: this.slidesPerView,
            slidesPerGroup: this.slidesPerView,
            spaceBetween: 15,
          },
        },
      });

    }

    show() {
      this.style.display = '';
      this.parentNode.style.display = '';
      this.style.visibility = '';
      this.parentNode.style.visibility = '';
    }
  }

  if (!window.customElements.get('activity-container')) {
    window.customElements.define('activity-container', ActivityContainer);
  }

})();